

























































import DetailsList from './scripts';
export default DetailsList;
